/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddOrUpdateUserTeamMemberRoleMutationVariables = Types.Exact<{
  teamId: Types.Scalars['String'];
  userRoles: Array<Types.UserRoleInput> | Types.UserRoleInput;
}>;


export type AddOrUpdateUserTeamMemberRoleMutation = { __typename?: 'Mutation', addOrUpdateUserTeamMemberRole: { __typename?: 'AddOrChangeUserTeamRole', ok: boolean | null | undefined } | null | undefined };


export const AddOrUpdateUserTeamMemberRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddOrUpdateUserTeamMemberRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userRoles"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRoleInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"addOrUpdateUserTeamMemberRole"},"name":{"kind":"Name","value":"add_or_change_user_team_role"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"user_roles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userRoles"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<AddOrUpdateUserTeamMemberRoleMutation, AddOrUpdateUserTeamMemberRoleMutationVariables>;
export const namedOperations = {
  Mutation: {
    AddOrUpdateUserTeamMemberRole: 'AddOrUpdateUserTeamMemberRole'
  }
}

export type AddOrUpdateUserTeamMemberRoleMutationFn = Apollo.MutationFunction<AddOrUpdateUserTeamMemberRoleMutation, AddOrUpdateUserTeamMemberRoleMutationVariables>;

/**
 * __useAddOrUpdateUserTeamMemberRoleMutation__
 *
 * To run a mutation, you first call `useAddOrUpdateUserTeamMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrUpdateUserTeamMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrUpdateUserTeamMemberRoleMutation, { data, loading, error }] = useAddOrUpdateUserTeamMemberRoleMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userRoles: // value for 'userRoles'
 *   },
 * });
 */
export function useAddOrUpdateUserTeamMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddOrUpdateUserTeamMemberRoleMutation, AddOrUpdateUserTeamMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrUpdateUserTeamMemberRoleMutation, AddOrUpdateUserTeamMemberRoleMutationVariables>(AddOrUpdateUserTeamMemberRoleDocument, options);
      }
export type AddOrUpdateUserTeamMemberRoleMutationHookResult = ReturnType<typeof useAddOrUpdateUserTeamMemberRoleMutation>;
export type AddOrUpdateUserTeamMemberRoleMutationResult = Apollo.MutationResult<AddOrUpdateUserTeamMemberRoleMutation>;
export type AddOrUpdateUserTeamMemberRoleMutationOptions = Apollo.BaseMutationOptions<AddOrUpdateUserTeamMemberRoleMutation, AddOrUpdateUserTeamMemberRoleMutationVariables>;